import { render, staticRenderFns } from "./LivePreview.vue?vue&type=template&id=bb6bf89c&scoped=true&"
import script from "./LivePreview.vue?vue&type=script&lang=js&"
export * from "./LivePreview.vue?vue&type=script&lang=js&"
import style0 from "./LivePreview.vue?vue&type=style&index=0&id=bb6bf89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6bf89c",
  null
  
)

export default component.exports